import { noveltyColours } from '../documents/noveltyColours'

/**
 * "84 — Highly novel" (figure S1).
 *
 * FOUR labels, and only four. The figure's own help text names the scale —
 * Highly novel / Moderately novel / Limited novelty / Low novelty — and the
 * thresholds are the app's existing ones (noveltyColours), so a claim cannot
 * read one band here and another on the document page. The v1 label appended
 * "— significant prior art" to the bottom band, which is a sentence about the
 * corpus rather than a name for the band, and it made the pill wrap.
 *
 * A claim the analysis never scored says so. It is not shown as 0, which reads
 * as "worthless" rather than "not looked at yet".
 */
export function claimBandLabel(score: number): string {
  if (score >= 80) return 'Highly novel'
  if (score >= 60) return 'Moderately novel'
  if (score >= 40) return 'Limited novelty'
  return 'Low novelty'
}

export interface ClaimScorePillProps {
  score: number | null | undefined
  size?: 'sm' | 'lg'
}

export default function ClaimScorePill({ score, size = 'sm' }: ClaimScorePillProps) {
  const pad = size === 'lg' ? 'px-3 py-1 text-[12px]' : 'px-2 py-0.5 text-[11px]'
  if (score == null) {
    return (
      <span
        className={`shrink-0 whitespace-nowrap rounded-full border border-sky-200 bg-white font-semibold text-gray-500 ${pad}`}
        title="The analysis has not scored this claim yet."
      >
        Not scored yet
      </span>
    )
  }
  const tone = noveltyColours(score)
  return (
    <span className={`shrink-0 whitespace-nowrap rounded-full font-semibold ${tone.bg} ${tone.text} ${pad}`}>
      {score} — {claimBandLabel(score)}
    </span>
  )
}
